export const video = {
  mission: {
    background: "https://images.unsplash.com/photo-1496096265110-f83ad7f96608?auto=format&fit=crop&w=1800&h=1000&q=80"
  },
  pricing: {
    background: "https://images.unsplash.com/photo-1462899006636-339e08d1844e?auto=format&fit=crop&w=1800&h=1000&q=80"
  }
};
